// Глобальная переменная для хранения ID виджета капчи
let captchaWidgetId = null
let captchaLoadPromise = null
let isSubmitting = false
let contactForm = null
let submitButton = null
let messageBox = null
let phoneInput = null

function setSubmitLoading(isLoading) {
  submitButton?.classList.toggle('btn--loader', isLoading)
}

function clearMessage() {
  if (!messageBox) {
    return
  }

  messageBox.textContent = ''
  messageBox.className = 'form-message'
}

// Функция инициализации SmartCaptcha (вызывается автоматически при загрузке скрипта)
window.smartCaptchaInit = function () {
  if (!window.smartCaptcha || captchaWidgetId !== null) {
    return captchaWidgetId !== null
  }

  const container = document.getElementById('captcha-container')
  if (!container) {
    return false
  }

  // Рендерим невидимую капчу
  captchaWidgetId = window.smartCaptcha.render(container, {
    sitekey: 'ysc1_Vg2ukbpVtYm3BPq0Nm8A5oJylZ03f3zX2zKZEhNY3e18bce2',
    invisible: true,
    callback: handleCaptchaSuccess,
    'error-callback': handleCaptchaError,
  })

  return captchaWidgetId !== null
}

// Лениво загружаем SmartCaptcha только при первой отправке формы
function loadCaptcha() {
  if (captchaWidgetId !== null) {
    return Promise.resolve()
  }

  if (captchaLoadPromise) {
    return captchaLoadPromise
  }

  captchaLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload'
    script.id = 'SmartCaptcha'
    script.async = true

    script.onload = () => {
      if (window.smartCaptcha && window.smartCaptchaInit()) {
        resolve()
      } else {
        reject(new Error('Виджет SmartCaptcha не создан'))
      }
    }

    script.onerror = () => {
      reject(new Error('Не удалось загрузить SmartCaptcha'))
    }

    document.head.appendChild(script)
  }).catch((error) => {
    captchaLoadPromise = null
    throw error
  })

  return captchaLoadPromise
}

// Callback функция при ошибке капчи
function handleCaptchaError() {
  isSubmitting = false
  setSubmitLoading(false)
  showMessage(messageBox, 'error', 'Ошибка проверки капчи. Попробуйте снова.')

  // Сбрасываем капчу
  if (window.smartCaptcha && captchaWidgetId !== null) {
    window.smartCaptcha.reset(captchaWidgetId)
  }
}

// Callback функция, которая вызывается после успешного прохождения капчи
function handleCaptchaSuccess(token) {
  if (!contactForm) {
    isSubmitting = false
    setSubmitLoading(false)
    return // если формы нет на странице, дроп
  }

  const formData = new FormData(contactForm)

  // Добавляем токен капчи
  formData.set('smart-token', token)

  // Удаляем поле date_submit из FormData
  formData.delete('date_submit')

  fetch('/backend/contact.php', {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 'success') {
        showMessage(messageBox, 'success', 'Заявка успешно отправлена')
        contactForm.reset()
      } else {
        showMessage(messageBox, 'error', data.message)
      }
    })
    .catch((error) => {
      showMessage(messageBox, 'error', 'Ошибка отправки формы')
      console.error('Ошибка:', error)
    })
    .finally(() => {
      isSubmitting = false
      setSubmitLoading(false)
      // Сбрасываем капчу для следующей отправки
      if (window.smartCaptcha && captchaWidgetId !== null) {
        window.smartCaptcha.reset(captchaWidgetId)
      }
    })
}

// Вспомогательная функция для отображения сообщений
function showMessage(messageBox, type, text) {
  messageBox.textContent = text
  messageBox.className = `form-message ${type}`
  clearTimeout(messageBox.hideTimer)
  messageBox.hideTimer = setTimeout(clearMessage, 5000)
}

document.addEventListener('DOMContentLoaded', () => {
  contactForm = document.getElementById('contactForm')
  messageBox = document.querySelector('.form-message')

  if (!contactForm) {
    return
  }

  submitButton = contactForm.querySelector('button[type="submit"]')
  phoneInput = contactForm.querySelector('.form-field__tel')

  contactForm.addEventListener('submit', (event) => {
    event.preventDefault()

    if (phoneInput?.phoneMask && !phoneInput.phoneMask.masked.isComplete) {
      phoneInput.setCustomValidity('Введите полный номер телефона')
    }

    if (!contactForm.checkValidity()) {
      contactForm.reportValidity()
      return
    }

    // Проверяем, не идет ли уже отправка
    if (isSubmitting) {
      return
    }

    isSubmitting = true
    setSubmitLoading(true)

    loadCaptcha()
      .then(() => {
        if (!window.smartCaptcha || captchaWidgetId === null) {
          throw new Error('Капча не загружена')
        }

        // Запускаем невидимую капчу
        window.smartCaptcha.execute(captchaWidgetId)
      })
      .catch((error) => {
        isSubmitting = false
        setSubmitLoading(false)
        console.error('Ошибка загрузки капчи:', error)
        showMessage(messageBox, 'error', 'Капча не загружена. Пожалуйста, попробуйте еще раз.')
      })
  })

  document.querySelectorAll('.file-input').forEach((input) => {
    const label = input.closest('.file-upload-label')
    const fileName = label.querySelector('.file-upload-name')
    const fileButton = label.querySelector('.file-upload-btn')
    const removeIcon = label.querySelector('.file-upload-remove')

    input.addEventListener('change', (event) => {
      const file = event.target.files[0]
      fileName.textContent = file ? file.name : ''
      fileButton.textContent = file ? 'Заменить' : 'Загрузить файл'
      removeIcon.style.display = file ? 'inline' : 'none'
    })

    removeIcon.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()
      input.value = ''
      fileName.textContent = ''
      fileButton.textContent = 'Загрузить файл'
      removeIcon.style.display = 'none'
    })
  })

  // Надо ручку попросить
  // fetch('', {
  //   method: 'POST',
  //   body: formData,
  // })
  //   .then((response) => response.json())
  //   .then((data) => {
  //     if (data.status === 'success') {
  //       showMessage('success', 'Заявка успешно отправлена')
  //       form.reset()
  //     } else {
  //       showMessage('error', data.message)
  //     }
  //   })
  //   .catch((error) => {
  //     showMessage('error', 'Ошибка отправки формы')
  //     console.error('Ошибка:', error)
  //   })
})
